import React, { useContext } from 'react';
import { bool, string } from 'prop-types';
import classNames from 'classnames/bind';
import { Image, Placeholder } from '@thd-olt-component-react/core-ui';
import { StorePodContext } from '../../StorePod.context';
import styles from './store-pod-services.module.scss';

const cx = classNames.bind(styles);

export const StorePodServices = ({ className, disablePlaceholder, showIcon }) => {
  const { loading, store } = useContext(StorePodContext);
  const { services, flags, orderPickUpLocker } = store;
  const {
    applianceShowroom,
    expandedFlooringShowroom,
    keyCutting,
    kitchenShowroom,
    largeEquipment,
    loadNGo,
    penske,
    propane,
    toolRental,
    wiFi
  } = services || {};
  const { bopisFlag, bodfsFlag } = flags || {};

  const allServices = [
    { available: applianceShowroom, name: 'Expanded Appliance Showroom', icon: 'appliance-gray' },
    { available: bodfsFlag, name: 'Buy Online Deliver from Store', icon: 'delivery-fill-gray' },
    { available: bopisFlag, name: 'Buy Online Pick Up in Store', icon: 'bopis-gray' },
    { available: expandedFlooringShowroom, name: 'Expanded Flooring Showroom', icon: 'flooring-gray' },
    { available: keyCutting, name: 'Key Cutting', icon: 'key-gray' },
    { available: kitchenShowroom, name: 'Kitchen Showroom', icon: 'kitchen-showroom-gray' },
    { available: largeEquipment, name: 'Large Equipment Rental', icon: 'equipment-gray' },
    { available: loadNGo, name: 'Home Depot Truck Rental', icon: 'boxtruck-gray' },
    { available: orderPickUpLocker, name: 'Order Pick Up Lockers', icon: 'order-pickup-locker-gray' },
    { available: penske, name: 'Moving Truck Rental', icon: 'bigtruck' },
    { available: propane, name: 'Propane Exchange', icon: 'propane-gray' },
    { available: toolRental, name: 'Tool Rental', icon: 'drill-gray' },
    { available: wiFi, name: 'Free WiFi', icon: 'wifi-gray' }
  ];

  const availableServices = allServices.filter((service) => service.available);

  const servicesClasses = cx(className, 'store-pod-services', {
    'store-pod-services--large': showIcon && !disablePlaceholder,
    'store-pod-services--small': !disablePlaceholder
  });

  const listClasses = cx('store-pod-services__list', {
    'store-pod-services__list--unstyled': showIcon
  });

  const listItemClasses = cx('store-pod-services__list-item', {
    'store-pod-services__list-item--fixed-height': showIcon
  });

  if (loading && !disablePlaceholder) {
    return (
      <div className={servicesClasses} data-testid="store-pod-services__loader">
        <Placeholder height={showIcon ? '650px' : '260px'} type="rect" width="100%" />
      </div>
    );
  }

  if (availableServices.length === 0 || (loading && disablePlaceholder)) { return null; }

  return (
    <div className={servicesClasses}>
      <ul className={listClasses}>
        {
          availableServices.map((service, index) => (
            <li className={listItemClasses} key={service.name}>
              {showIcon && (
                <Image
                  alt=""
                  className={cx('store-pod-services__icon')}
                  height="50"
                  width="50"
                  asset={`${service.icon}.svg`}
                />
              )}
              <span>{service.name}</span>
            </li>
          ))
        }
      </ul>
    </div>
  );
};

StorePodServices.propTypes = {
  className: string,
  disablePlaceholder: bool,
  showIcon: bool
};

StorePodServices.defaultProps = {
  className: null,
  disablePlaceholder: false,
  showIcon: false
};

StorePodServices.displayName = 'StorePodServices';
